<template>
  <div>

<pages_wrapper   :pages="pages"> </pages_wrapper>

  </div>
</template>




<script>
import axios from 'axios'
import pages_wrapper from './pages_wrapper.vue'
export default {
components: {pages_wrapper},
 data: function(){
  return {
pages:{

  renameList: {
    title: '',
    loading: false,
  },
  removeList: {
    loading: false,
  },
  selectedCat: 'Общий список',
  catList: [],

  loading: true,
  lastQ: "",
  q:"",
  all:[],
  active:[],
  beforeDisplayed:[],
  selected:[],
  selector: false,
  checkList: [],
  deleteId: [],
  modals :{
    addPages:false,
    deletePages: false,
    deleteSelected: false,
    checkPages: false,
    history: false,
    changeCatSelected: false,
    renameCatSelected: false,
    removeCatSelected: false,
  },
  history: {
        historyId: '',
        mode:"followers",  //  followers_out, friends, friends_out

    followers:{
        foundData:{
         selector: false,
         foundIds: [],
         displayIds: [],
         selectedIds: [],
         offset: 0,
       },
     },
     followers_out:{
         foundData:{
          selector: false,
          foundIds: [],
          displayIds: [],
          selectedIds: [],
          offset: 0,
        },
      },
     friends:{
         foundData:{
          selector: false,
          foundIds: [],
          displayIds: [],
          selectedIds: [],
          offset: 0,
        },
      },
      friends_out:{
          foundData:{
           selector: false,
           foundIds: [],
           displayIds: [],
           selectedIds: [],
           offset: 0,
         },
       },
        pages: {
          q: "",
          offset: 0 ,
          displayed: [],
          all_in: [],
          all_out: [],
        },


  },
  checker: {

 mode:"followers",  //  followers_out, friends, friends_out

followers:{
    foundData:{
     selector: false,
     foundIds: [],
     displayIds: [],
     selectedIds: [],
     offset: 0,
   },
 },
 followers_out:{
     foundData:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
    },
  },
 friends:{
     foundData:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
    },
  },
  friends_out:{
      foundData:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
     },
   },
   friends_out_to_followers:{
       foundData:{
        selector: false,
        foundIds: [],
        displayIds: [],
        selectedIds: [],
        offset: 0,
      },
    },
   followerInContentMenegment: {
    marginTop: '0px',
    snackbarAbsoute: true,
    items: {
      selector: {active:true},
      copy: {active:true},
      export: {active:true},
      autoExport: {active:false},
      update: {active:false},
      delete: {active:false},
    },
    contentInfo: {
      type: 'pages',
    },
    autoExport: {
      saveSourceInfo: false,
      isActive: false,
      tasksList:[],

    },
    txtAutoExport : {
      pattern: {},
      isActive: false,
    },

   },

   followerOutContentMenegment: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false}
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],

     }

    },

    friendsInContentMenegment: {
      marginTop: '0px',
      snackbarAbsoute: true,
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        isActive: false,
        tasksList:[],

      }

     },

     friendsOutContentMenegment: {
       marginTop: '0px',
       snackbarAbsoute: true,
       items: {
         selector: {active:true},
         copy: {active:true},
         export: {active:true},
         update: {active:false},
         delete: {active:false},
         autoExport: {active:false}
       },
       contentInfo: {
         type: 'pages',
       },
       autoExport: {
         isActive: false,
         tasksList:[],

       }

      },
      friendsOutToFollowersContentMenegment: {
        marginTop: '0px',
        snackbarAbsoute: true,
        items: {
          selector: {active:true},
          copy: {active:true},
          export: {active:true},
          update: {active:false},
          delete: {active:false},
          autoExport: {active:false}
        },
        contentInfo: {
          type: 'pages',
        },
        autoExport: {
          isActive: false,
          tasksList:[],

        }

       },
  },
},
updater: {
  id : "",
  status : true
}

  }
},
created(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_get_by_list.php', {
       method: 'POST',
       data : {catList:this.pages.catList, selectedCat:this.pages.selectedCat },
     }).then(response => {
 this.pages.catList = response.data.catList
 this.pages.selectedCat = response.data.selectedCat
 this.pages.loading = false
 this.pages.all = response.data.pages
     })

},
mounted( ){
this.updater.id =   setInterval( ()=>{

  if(this.pages.selected.length<1){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_get_by_list.php', {
         method: 'POST',
         data : {catList:this.pages.catList, selectedCat:this.pages.selectedCat },
       }).then(response => {
          this.pages.catList = response.data.catList
          this.pages.selectedCat = response.data.selectedCat
          this.pages.loading = false
          if(response.data.pages.length>0){
            this.pages.all =  response.data.pages
          }

       })
}

  }, 8000)
},
destroyed(){
 clearInterval(this.updater.id)

},
computed:{

},


}
</script>

<style>

</style>
